import { DOCUMENT } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-gfcore-route',
  standalone: true,
  template: `
    <main class="route-bridge">
      <div class="route-bridge__label">Opening workspace…</div>
      <h1>Redirecting to Gfcore</h1>
      <p>Your authenticated workspace is loading.</p>
    </main>
  `
})
export class GfcoreRouteComponent implements OnInit {
  private readonly document = inject(DOCUMENT);
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    const gfcorePage = String(this.route.snapshot.data['gfcorePage'] || 'build-improve-page').trim();
    const targetUrl = new URL('/gfcore/index.html', this.document.location.origin);
    const currentUrl = new URL(this.document.location.href);

    currentUrl.searchParams.forEach((value, key) => {
      if (key !== 'page') {
        targetUrl.searchParams.set(key, value);
      }
    });

    targetUrl.searchParams.set('page', gfcorePage);
    targetUrl.hash = this.document.location.hash;
    this.document.location.replace(targetUrl.toString());
  }
}
